import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { loadCrmProfile, setActiveBranch } from '@crm/features/auth/crmAuthSlice';

export function BranchLayout() {
  const dispatch = useDispatch();
  const { branchId } = useParams();
  const { profile, status } = useSelector((s) => s.crmAuth);

  /** После restoreCrmSession статус authenticated, а profile/branches пустые — нужен /me. */
  useEffect(() => {
    if (!profile && status === 'authenticated') {
      dispatch(loadCrmProfile());
    }
  }, [dispatch, profile, status]);

  useEffect(() => {
    dispatch(setActiveBranch(branchId));
  }, [dispatch, branchId]);

  return <Outlet />;
}
